/**
 * Explore page carousel — the shared definition of the `explore_carousel_order`
 * field. Redmine #265265.
 *
 * Same shape as constants/homeCollage.js and for the same reason: one definition
 * for the six Masterlist forms, so no form's range can drift from the backend's.
 *
 * MAX_EXPLORE_CAROUSEL_ORDER comes from REACT_APP_EXPLORE_CAROUSEL_SIZE (default 5)
 * and must match the backend's EXPLORE_CAROUSEL_SIZE (constants/exploreCarousel.js).
 * CRA inlines REACT_APP_* at build time, so a change needs a rebuild. The backend
 * is the authority: it rejects anything outside its own range, and rejects a slot
 * already held by another record with a message naming that record.
 */

const parsedSize = Number.parseInt(
  process.env.REACT_APP_EXPLORE_CAROUSEL_SIZE,
  10,
);

export const MAX_EXPLORE_CAROUSEL_ORDER =
  Number.isFinite(parsedSize) && parsedSize > 0 ? parsedSize : 5;

export const EXPLORE_CAROUSEL_ORDER_HELP =
  `Assign a unique slot from 1–${MAX_EXPLORE_CAROUSEL_ORDER} to show this record in the ` +
  `Explore page carousel. Leave empty to keep it out. Each slot may be used by only one record.`;

/**
 * The JSON Schema fragment. Nullable on purpose: clearing the field is how a
 * record is REMOVED from the carousel.
 */
export const exploreCarouselOrderSchema = () => ({
  type: ["integer", "null"],
  title: "Explore Carousel Order",
  minimum: 1,
  maximum: MAX_EXPLORE_CAROUSEL_ORDER,
  description: EXPLORE_CAROUSEL_ORDER_HELP,
});

/**
 * The uiSchema fragment. ui:emptyValue is null, not "" -- an empty string would
 * reach the backend as a non-integer and be rejected.
 */
export const exploreCarouselOrderUiSchema = () => ({
  "ui:emptyValue": null,
  "ui:placeholder": `1–${MAX_EXPLORE_CAROUSEL_ORDER}, or leave empty`,
});
